// Firebase initialization in a single module
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB9P2UONlzELvK7sGPT13L1zMKSq0CRnr0",
  authDomain: "hcp-app-b47d2.firebaseapp.com",
  projectId: "hcp-app-b47d2",
  storageBucket: "hcp-app-b47d2.firebasestorage.app",
  messagingSenderId: "821811288838",
  appId: "1:821811288838:web:4928ce9afe804f6cb61c87",
  measurementId: "G-W87WPH6CTF",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export default db;
export { analytics };
